// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface String {
    format(...replacements: (string | number)[]): string
}

if (!String.prototype.format) {
    String.prototype.format = function (...args): string {
        return this.replace(/{(\d+)}/g, (match: any, number: any) => {
            return typeof args[number] !== 'undefined' ? args[number] : match
        })
    }
}
